import {
  GET_TRIP_TRAFFIC_RULES
} from '../actionTypes';
import {
  PENDING,
  SUCCESS,
  FAILURE
} from '../../utils/status';

import * as trafficRulesService from '../../services/trafficRules';


export function getTripTrafficRules(trip_id) {
  return function (dispatch) {
    dispatch({
      type: GET_TRIP_TRAFFIC_RULES,
      status: PENDING
    });

    return trafficRulesService.getListByTripId(trip_id)
      .then(function (data) {
        dispatch({
          type: GET_TRIP_TRAFFIC_RULES,
          status: SUCCESS,
          data: data
        });

        return data;
      })
      .catch(function (err) {
        dispatch({
          type: GET_TRIP_TRAFFIC_RULES,
          status: FAILURE,
          data: err
        });
      });
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/trafficRules.js